import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes";

export default class Proveedor extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                nombre: '',
                razon_social: '',
                nit: '',
                direccion: '',
                telefono: '',
                correo: '',
                regimen: null
            },
            colapsar: true,
            camposRequeridos: [],
        };
    }

    componentDidMount() {
        const { registro } = this.state;
        if (registro["nombre"] == null) {
            registro["nombre"] = "";
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro

            if (_valid(registro.id)) {

                this.apiRest.put('/proveedorDetalle/' + registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/proveedorLista');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {

                this.apiRest.post('/proveedor', registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/proveedorLista');
                        this.setState({ registro: resultado.data })
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    datosRegistroValidos() {
        const { camposRequeridos } = this.state;
        
        let existenErrores = false
        if (!_valid(this.state.registro.nombre)) {
            camposRequeridos.push("Nombre ");
            existenErrores = true;
        }
        if (!_valid(this.state.registro.razon_social)) {
            camposRequeridos.push("Rázon Social ");
            existenErrores = true;
        }
        if (!_valid(this.state.registro.nit)) {
            camposRequeridos.push("NIT ");
            existenErrores = true;
        }
        if (!_valid(this.state.registro.direccion)) {
            camposRequeridos.push("Dirección ");
            existenErrores = true;
        }
        if (!_valid(this.state.registro.telefono)) {
            camposRequeridos.push("Teléfono ");
            existenErrores = true;
        }
        if (!this.verificarTelefono(this.state.registro.telefono)) {
            camposRequeridos.push("Número de teléfono no es válido ");
            existenErrores = true;
        }
        if (!_valid(this.state.registro.regimen)) {
            camposRequeridos.push("Regimen ");
            existenErrores = true;
        }

        if (existenErrores) {
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);
        }

        return !existenErrores;
    }

    verificarTelefono(numero) {
        if (numero.toString().length === 8) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        const { registro, colapsar, camposRequeridos } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Proveedor" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Proveedor</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar nombres"
                                                                        maxLength="150"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="razon_social" className="form-label">
                                                                        Raz&oacute;n Social
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.razon_social}
                                                                        onChange={this.actualizarValores}
                                                                        name="razon_social"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar Razón Social"
                                                                        maxLength="150"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nit" className="form-label">
                                                                        NIT
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nit}
                                                                        onChange={this.actualizarValores}
                                                                        name="nit"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar NIT"
                                                                        maxLength="150"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="direccion" className="form-label">
                                                                        Direcci&oacute;n
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.direccion}
                                                                        onChange={this.actualizarValores}
                                                                        name="direccion"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar direccion"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="telefono" className="form-label">
                                                                        Telefono
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.telefono}
                                                                        onChange={this.actualizarValores}
                                                                        name="telefono"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingrese numero de telefono"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="correo" className="form-label">
                                                                        Correo Electronico
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.correo}
                                                                        onChange={this.actualizarValores}
                                                                        name="correo"
                                                                        type="mail"
                                                                        className="form-control"
                                                                        placeholder="Ingresar correo electronico"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                        <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="regimen" className="form-label">
                                                                        R&eacute;gimen
                                                                    </Label>
                                                                    <select
                                                                        value={registro.regimen}
                                                                        onChange={this.actualizarValores}
                                                                        name="regimen"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="">Seleccionar</option>
                                                                        <option value="0">Régimen sobre ingreso</option>
                                                                        <option value="1">Régimen sobre utilidades</option>
                                                                        <option value="2">Pequeño contribuyente</option>
                                                                        <option value="3">Excentos</option>
                                                                        <option value="4">Agente de retencion</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/proveedorLista') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}